import { createContext } from 'react';
import * as Sift from '@sift/types';

export default createContext<null | Sift.Configuration>(null);
